import { makeAutoObservable, action } from 'mobx'
import { isArray, keyBy, isObject, isEmpty, cloneDeep, map, forEach, sortBy } from '@dt/fe-utils/dist/lodash'

/** 手机装修mobx */
class DecorationStore {
  constructor () {
    makeAutoObservable(this)
  }

  nearStore: IViewStore
  storeCityMap: { [key: string]: IViewStore[] } = {}
  storeCityList: { list: IViewStore[]; key: string }[] = []

  setStoreList (stores: IViewStore[]) {
    let hasLbs = Config.LBS.latitude > 0 && Config.LBS.longitude > 0
    let list = hasLbs ? sortBy(cloneDeep(stores), (store) => store.distance) : sortBy(cloneDeep(stores), (store) => store?.city?.county)
    let cityMap = {}
    let cityList = []
    let index = -1
    forEach(list, (store) => {
      const county = store?.city?.county
      if (store.status !== 'closing' && !!store.saleResourceInfo?.base && county) {
        if (cityMap[county]) {
          cityMap[county].push(store)
          cityList[index].list.push(store)
        } else {
          index++
          cityMap[county] = [store]
          cityList[index] = {
            key: county,
            list: [store]
          }
        }
      }
    })
    this.nearStore = list[0]
    this.storeCityList = sortBy(cityList, (item) => hasLbs && list[0]?.city?.county === item.key ? -9999 : -item.list.length)
    this.storeCityMap = cityMap
  }

  // 外边距8px 1.6%；参数multiple倍数
  getWidthPer (multiple = 1) {
    return window.innerWidth * 0.016 * multiple
  }
  /** 瀑布流计算，支持计算中同时计算图片延迟加载 */
  waterfall (list: any[], boxEle: HTMLElement) {
    const waterfallWrap = boxEle
    if (!waterfallWrap) {
      return
    }
    let overOff = 0
    let indexPostionMap: any = {}
    const itemWidth = window.innerWidth / 2 - this.getWidthPer(3)
    // document.body.style.setProperty('--storedisplaywateritemwidth', itemWidth + 'px')
    // 当前容器距离顶部的距离
    const offsetTop = 0
    let left = this.getWidthPer(2)
    let top = 0 + overOff
    let lt = 0 + overOff
    let rt = 0 + overOff
    // 容器高度
    let maxH = 100 // 阀值100
    const needReCalc = list.find((store, index) => {
      const id = store.storeId
      // 使用后计算方案
      const $height = document.getElementById(`store-display-${id}`)
      // 找不到
      if (!$height) {
        console.log('🚌 瀑布流计算失败，需要重算')
        return true
      }
      const thisHeight: number = $height.offsetHeight
      // TODO 更精准的异常处理
      if (thisHeight === 0) {
        return true
      }
      if (lt <= rt) {
        left = this.getWidthPer(2)
        top = lt
        lt += thisHeight + 16
      } else {
        left = this.getWidthPer(4) + itemWidth
        top = rt
        rt += thisHeight + 16
      }
      indexPostionMap[id] = {
        left,
        top,
        width: itemWidth,
        height: thisHeight,
        imgWidth: itemWidth,
      }
      if (maxH < top + thisHeight) {
        maxH = top + thisHeight
      }
    })
    if (needReCalc) {
      return
    }
    return { styleMap: indexPostionMap, height: maxH + 10, offsetTop }
  }
}

export default new DecorationStore()
